<template>
    <b-form-group :label="variable.description">
        <b-button id="login-main" class="btn btn-soft-primary login-main" @click="login()" :disabled="loading || loginComplete">
            {{ loginText }}
        </b-button>
        <b-button id="login-retry" class="btn btn-sm text-primary text-decoration-none" variant="link" @click="login()" v-if="loginComplete">
            <i class="fa fa-sync-alt fa-fw" aria-hidden="true"></i>
            Switch User
        </b-button>
    </b-form-group>
</template>

<script>
export default {
    name: "Discord",
    props: {
        variable: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            loading: false,
            childWindow: null,
            loginComplete: false,
            loginUrl: window.tebex.application.login.discord,
            discordTag: null,
            modalWidth: 700,
            modalHeight: 700,
        }
    },
    computed: {
        modalLeft() {
            return window.outerWidth / 2 + window.screenX - ( this.modalWidth / 2);
        },
        modalTop() {
            return window.outerHeight / 2 + window.screenY - ( this.modalHeight / 2);
        },
        modalFeatures() {
            return `width=${this.modalWidth},height=${this.modalHeight},top=${this.modalTop},left=${this.modalLeft},popup`;
        },
        loginText() {
            if (this.loginComplete && this.discordTag !== null) {
                return 'Logged in as ' + this.discordTag;
            }

            return 'Login with Discord'
        }
    },
    methods: {
        login() {
            this.loading = true;

            this.childWindow && !this.childWindow.closed ? this.childWindow.focus() : this.openWindow();

            this.loading = false;
        },
        openWindow() {
            this.childWindow = window.open(this.loginUrl, '_blank', this.modalFeatures);

            //Process login-details
            window.addEventListener('message', (message) => {
                if (message.origin !== 'https://checkout.tebex.io' || message.data['source'] !== 'discord-login') {
                    return;
                }

                this.processLoginDetails(message);
            });

            //Close alongside parent window
            window.addEventListener('beforeunload', () => {
                this.childWindow.close();
            });

        },
        processLoginDetails(message) {
            let payload = message.data['payload'];

            if (!payload) {
                this.$swal({type: 'error', text: 'Could not complete Discord login.'});
                return this.childWindow.close();
            }

            this.discordTag = payload['discordTag'];
            this.variable.value = payload['discordId'];
            this.variable.discordSignature = payload['signature'];

            this.loginComplete = true;
            this.childWindow.close();
        }
    }
}
</script>

<style>
    #login-main {
        width: 100% !important;
    }

    #login-retry {
        text-transform: unset !important;
        padding-left: unset !important;
    }
</style>
